export const versions = [
  {
    version: "v6.8.2",
    platform: "安卓",
    date: "2026-09-28",
    size: "86.4 MB",
    tag: "最新",
    highlights: [
      "新增竖屏连续播放模式，上下滑动衔接更顺滑",
      "修复部分机型安装后启动闪退的问题",
      "优化视频加载策略，打开速度约提升 30%",
    ],
  },
  {
    version: "v6.8.0",
    platform: "苹果",
    date: "2026-09-20",
    size: "112.7 MB",
    tag: "最新",
    highlights: [
      "适配 iOS 18 系统，兼容性进一步优化",
      "支持画中画小窗播放，切换应用不中断",
      "优化夜间模式配色，长时间观看更护眼",
    ],
  },
  {
    version: "v6.7.5",
    platform: "安卓",
    date: "2026-09-05",
    size: "85.1 MB",
    tag: "",
    highlights: [
      "修复弹幕遮挡关键画面区域的问题",
      "新增本地缓存管理，可一键清理占用空间",
    ],
  },
  {
    version: "v6.7.0",
    platform: "苹果",
    date: "2026-08-22",
    size: "110.3 MB",
    tag: "",
    highlights: [
      "上线兴趣标签推荐，内容更贴合个人偏好",
      "简化登录流程，支持一键获取验证码",
    ],
  },
  {
    version: "v6.6.0",
    platform: "安卓",
    date: "2026-08-08",
    size: "83.6 MB",
    tag: "",
    highlights: [
      "新增社区话题标签，便于发现同好内容",
      "优化播放器手势，双击快退与长按倍速更灵敏",
    ],
  },
];

export const versionFilters = [
  { key: "all", label: "全部版本" },
  { key: "安卓", label: "安卓版" },
  { key: "苹果", label: "苹果版" },
];